import { isUndefined } from '~/util/validators/baseComponentsValidators'
import { createState } from '~/util/storeHelpers'
const cashboxPromotions = createState({ key: 'cashboxPromotions', initialValue: [] })
export const state = () => ({
  cashboxPromotions: cashboxPromotions.state,
  promotionsProgress: [],
  showLoader: false,
  isFetchingCashboxPromotion: false,
  partnerBanners: {},
  activatedPromotions: [],
  newPromotions: {
    data: 0,
    isLoading: false,
    error: null,
  },
  bonusesListTriggered: {},
  promotionsTrack: [],
})

export const mutations = {
  set_newPromotions(state, { data, isLoading, error }) {
    const key = 'newPromotions'

    if (!isUndefined(data)) state[key].data = data
    if (!isUndefined(isLoading)) state[key].isLoading = isLoading
    if (!isUndefined(error)) state[key].error = error
  },
  reset_newPromotions(state) {
    state.newPromotions.data = 0
    state.newPromotions.isLoading = false
    state.newPromotions.error = null
  },

  set_cashboxPromotions(state, { promotions }) {
    const parsedCashboxPromotions = []
    promotions.forEach(elem => {
      const promotionBoilerplate = {
        code: '',
        reward_types: [],
        rewards: {},
        ru: {
          title: '',
          description: '',
        },
        ua: {
          title: '',
          description: '',
        },
      }

      if (typeof elem.conditions === 'string') {
        elem.conditions = JSON.parse(elem.conditions)
      }
      const modifiedPromotion = Object.assign(promotionBoilerplate, elem)
      parsedCashboxPromotions.push(modifiedPromotion)
    })
    cashboxPromotions.setter(state, { data: parsedCashboxPromotions })
    state.showLoader = false
  },
  set_promotionProgress(state, { promotionsProgress }) {
    state.promotionsProgress = promotionsProgress
    state.showLoader = false
  },
  set_showLoaderTrue(state) {
    state.showLoader = true
  },
  set_IsFetchingCashboxPromotion(state, payload) {
    state.isFetchingCashboxPromotion = payload
  },
  add_PartnerBanners(state, data) {
    state.partnerBanners = data
  },
  set_cashboxActivatedPromotions(state, { activatedPromotions }) {
    state.activatedPromotions = activatedPromotions
  },
  add_bonusesListTriggered(state, data) {
    state.bonusesListTriggered = data
  },
  set_promotionsTrack(state, data) {
    state.promotionsTrack = data
  },
}

export const actions = {
  async fetch_newPromotions({ commit, state }) {
    if (state.newPromotions.isLoading) return

    commit('set_newPromotions', { isLoading: true })
    try {
      const resp = await this.$api.userPromotions.countNew()
      if (!resp || !resp.data || !resp.data.status) commit('set_newPromotions', { error: new Error('Error during fetching promotions') })
      else commit('set_newPromotions', { data: resp.data.count || 0 })
    }
    catch (e) {
      commit('set_newPromotions', { error: e })
    }
    finally {
      commit('set_newPromotions', { isLoading: false })
    }
  },
  async add_newPromotions({ commit, state }) {
    const newPromotionsAmount = state.newPromotions.data + 1
    commit('set_newPromotions', { data: newPromotionsAmount })
  },
  async read_newPromotions({ commit }, { promotion_ids }) {
    try {
      const resp = await this.$api.userPromotions.markAsSeen({ promotion_ids })
      if (resp.data && resp.data.status) commit('set_newPromotions', { data: resp.data.count })
      else commit('set_newPromotions', { error: resp.data.error })
    }
    catch (e) {
      commit('set_newPromotions', { error: e })
    }
  },
  reset_newPromotions({ commit }) {
    commit('reset_newPromotions')
  },
  async fetch_cashboxPromotions(context) {
    context.commit('set_showLoaderTrue')
    if (context.state.isFetchingCashboxPromotion) return

    context.commit('set_IsFetchingCashboxPromotion', true)

    const res = await this.$api.userPromotions.cashbox()

    context.commit('set_IsFetchingCashboxPromotion', false)

    context.commit('set_cashboxPromotions', {
      promotions: res.data.promotions,
    })

    context.commit('set_cashboxActivatedPromotions', {
      activatedPromotions: res.data.activatedPromotions,
    })
  },
  async fetch_promotionProgress(context) {
    if (context.getters.get_showLoader) return
    context.commit('set_showLoaderTrue')
    const res = await this.$api.userPromotions.getPromotionProgress()
    context.commit('set_promotionProgress', {
      promotionsProgress: res.data.bonuses,
    })
  },
  async fetch_partnerBanners({ commit }, { query }) {
    try {
      const res = await this.$api.seo.partnerBanners({ query })
      commit('add_PartnerBanners', res.data)
    }
    catch (error) {
      console.log(error)
    }
  },
  async fetch_bonusesListTriggered({ commit }) {
    try {
      const res = await this.$api.userPromotions.getListTriggered()
      commit('add_bonusesListTriggered', res.data.data)
    }
    catch (error) {
      console.log(error)
    }
  },
  async fetch_promotionsTrack({ commit }) {
    try {
      const response = await this.$api.userPromotions.promotionsTrack()
      const { status, data } = response?.data

      if (status && Array.isArray(data)) {
        commit('set_promotionsTrack', data)
      }

      return response
    }
    catch (error) {
      console.log(error)
    }
  },
}

export const getters = {
  get_cashboxPromotions: cashboxPromotions.getter,
  get_promotionProgress: state => state.promotionsProgress,
  get_showLoader: state => state.showLoader,
  get_partnerBanners: state => state.partnerBanners || {},
  get_activatedPromotions: state => state.activatedPromotions,
  get_newPromotions: state => state.newPromotions,
  get_bonusesListTriggered: state => state.bonusesListTriggered,
  get_promotionMinExpire: (state) => {
    const minExpireValues = state.promotionsTrack?.map((item) => item?.expired_at) || []
    const minValue = Math.min(...minExpireValues)

    if (Number.isNaN(minValue) || Math.sign(minValue) !== 1 || !isFinite(minValue)) return {}

    const findItem = { ...state.promotionsTrack.find(item => item?.expired_at === minValue) }
    return findItem
  },
}
